<template>
  <v-layout>
    <v-flex>
      <v-layout wrap align-center>
        <h1 class="headline">Package</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 class="pb-2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="search"
            class="ma-0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              fab
              dark
              color="primary"
              @click="onCreateItem"
              class="ma-2"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Other Type</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="id"
          fixed-header
          hide-default-footer
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="onDeleteItem($event)"
              @editItem="onEditItem($event)"
            ></default-list-actions>
          </template>
          <template v-slot:item.hidden="{ item }">
            <v-layout justify-center>
              <v-checkbox
                v-model="item.hidden"
                hide-details
                :disabled="true"
                class="pa-0 ma-0"
              ></v-checkbox>
            </v-layout>
          </template>
          <template v-slot:item.notInUse="{ item }">
            <v-simple-checkbox
              v-model="item.notInUse"
              disabled
            ></v-simple-checkbox>
          </template>
        </v-data-table>
      </v-card>
      <other-type-edit-dialog
        :show="showEditDialog"
        @close="showEditDialog = false"
        v-model="editedItem"
        @input="onSave"
        item-type-label="Package Type"
      ></other-type-edit-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_PACKAGE_SERVICE_TYPES_SEARCH_QUERY,
  PACKAGE_SERVICE_TYPE_CREATE_MUTATION,
  PACKAGE_SERVICE_TYPE_DELETE_MUTATION,
  PACKAGE_SERVICE_TYPE_UPDATE_MUTATION,
} from "../../../../constants/graphql";

import DefaultListActions from "../../shared/DefaultListActions";
import { pagingOptions } from "../../../../helpers/index";
import SimpleListMixin from "../../../../mixins/SimpleListMixin";
import BasicCrudMixin from "../../../../mixins/BasicCRUD";
import OtherTypeEditDialog from "./OtherTypeEditDialog";
export default {
  name: "PackageTypesList",

  mixins: [SimpleListMixin, BasicCrudMixin],

  components: {
    DefaultListActions,
    OtherTypeEditDialog,
  },

  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Sales Nominal Code",
          value: "salesNominalCode",
          name: "salesNominalCode",
        },
        {
          text: "Purchase Nominal Code",
          value: "purchaseNominalCode",
          name: "purchaseNominalCode",
        },
        {
          text: "Tax Code",
          value: "taxCode",
          name: "taxCode",
        },
        {
          text: "Hidden",
          value: "hidden",
          name: "hidden",
        },
        {
          text: "Std Occupancy",
          align: "left",
          value: "stdOccupancy",
          sortable: true,
          name: "stdOccupancy",
        },
        {
          text: "Min Occupancy",
          align: "left",
          value: "minOccupancy",
          sortable: true,
          name: "minOccupancy",
        },
        {
          text: "Max Occupancy",
          align: "left",
          value: "maxOccupancy",
          sortable: true,
          name: "maxOccupancy",
        },
        {
          text: "Not In Use",
          value: "notInUse",
          name: "notInUse",
          align: "center",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
        },
      ],
      listQuery: ALL_PACKAGE_SERVICE_TYPES_SEARCH_QUERY,
      deleteMutation: PACKAGE_SERVICE_TYPE_DELETE_MUTATION,
      createMutation: PACKAGE_SERVICE_TYPE_CREATE_MUTATION,
      updateMutation: PACKAGE_SERVICE_TYPE_UPDATE_MUTATION,
      modelLabel: "Package Type",
      GQLtypeName: "packageServiceTypes",
    };
  },

  apollo: {
    packageServiceTypes: {
      query: ALL_PACKAGE_SERVICE_TYPES_SEARCH_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/PackageTypesList.vue